import React, { useEffect, useState } from "react";
import AgentProfileForm from "./AgentProfileForm";
import { useMsal } from "@azure/msal-react";
import { AddAgentProfile, UpdateAgentProfile, GetAgentProfile } from "../../Services/HeedifyServices";
import { getAccessToken } from "../../Services/GraphServices";
import { Add20Filled, Edit20Filled, Dismiss20Regular, Save20Regular, Edit20Regular } from "@fluentui/react-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useNotification } from "../GenericComponent/NotificationSystem";
import { useTranslation } from "react-i18next";
import "../CSS/AgentProfileForm.css";
import {
  Tab,
  TabList,
  Button,
  Spinner,
  Label,
} from "@fluentui/react-components";
const AgentsProfileComponent = (props) => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const activeAccount = accounts?.[0];
  const { showSuccess, showError } = useNotification();
  const { t } = useTranslation();
  const tenantId = props.ACTIVE_TENANT || activeAccount?.tenantId || null;

  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { profileId } = useParams(); // For update/edit mode
  const isEditMode = profileId && profileId !== "newProfile";

  const [profile, setProfile] = useState({
    displayName: "",
    region: "",
  });
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(true);
  // Fetch profile if in edit mode
  useEffect(() => {
    if (isEditMode) {
      getAccessToken(instance, activeAccount)
     
        .then((token) => GetAgentProfile(tenantId, profileId, token))
        .then((result) => {
          if (result.success && result.data) {
            setProfile(result.data);
          }
        })
        .catch((err) => console.error("❌ Error fetching profile:", err))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [profileId, instance, activeAccount, tenantId, isEditMode]);

  const handleSave = (data) => {
    setSaving(true);
    getAccessToken(instance, activeAccount)
      .then((token) => {
        if (isEditMode) {
          return UpdateAgentProfile(tenantId, profileId, data, token);
        } else {
          return AddAgentProfile(tenantId, data, token);
        }
      })
      .then((result) => {
        if (result?.success && result?.data) {
          const newProfile = result.data;

          // Merge new/updated profile into existing profiles
          const updatedProfiles = {
            ...props.AGENT_PROFILES,
            [newProfile.id]: newProfile,
          };
          props.setAgentProfiles(updatedProfiles);
          
          if (isEditMode) {
            showSuccess(t("AGENT_PROFILE_UPDATED_SUCCESS"));
          } else {
            showSuccess(t("AGENT_PROFILE_CREATED_SUCCESS"));
          }
          navigate("/agentsProfiles");
        } else {
          if (isEditMode) {
            showError(t("AGENT_PROFILE_UPDATE_FAILED"));
          } else {
            showError(t("AGENT_PROFILE_CREATION_FAILED"));
          }
        }
      })
      .catch((error) => {
        console.error("❌ Error while saving agent profile:", error);
        if (isEditMode) {
          showError(t("AGENT_PROFILE_UPDATE_ERROR"));
        } else {
          showError(t("AGENT_PROFILE_CREATION_ERROR"));
        }
      })
      .finally(() => {
        setSaving(false);
      });
  };
  if (loading) return <div>Loading...</div>;
  return (
    <>
    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'flex-end' }}>
      <Button
        icon={<Dismiss20Regular />}
        appearance="secondary"
        onClick={() => navigate("/agentsProfiles")}
      >
        {t("CANCEL")}
      </Button>
      <Button
        icon={saving ? <Spinner size="tiny" /> : (isEditMode ? <Edit20Regular /> : <Save20Regular />)}
        className="agent-profile-btn-add-style"
        disabled={!formValid || saving}
        appearance="primary"
        onClick={() => handleSave(profile)}
      >
        {saving ? t("SAVING") : t("SAVE")}
      </Button>
    </div>
    <div style={{ marginLeft: '8rem', marginRight: '8rem' , display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
     <AgentProfileForm
      profile={profile}
      setProfile={setProfile}
      formValid={formValid}
      setFormValid={setFormValid}
      onSave={handleSave}
      isEditMode={isEditMode}
    /></div></>
   
  );
};

export default AgentsProfileComponent;
